import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { ReportType } from '../../../config/complaintReport';
import complaintReportService from '../../../service/NewComplaint/complaintReport.service';

const ComplaintReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autoCompleteOptions,
  autocompleteData,
  type,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'supplier', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    const enhancedState = {
      ...gridState,
      filter: {
        ...gridState.filter,
        filterModel: {
          ...gridState.filter?.filterModel,
          items: [
            ...gridState.filter?.filterModel?.items,
            {
              field: 'type',
              operator: 'is',
              id: 'type-filter',
              value: type,
            },
          ],
          logicOperator: gridState.filter?.filterModel?.logicOperator,
        },
      },
    };

    complaintReportService.getItems(enhancedState).then((data) => {
      setReports(data);
    });
  };

  const complaintValueOptions = autoCompleteOptions?.complaints?.map((option) => ({
    value: option.value,
    label: option.fullLabel,
  }));

  const columns = dataGridPremiumColumns([
    {
      field: 'supplier',
      headerName: 'Beszállító',
      type: 'string',
    },
    {
      field: 'supplierContactPersonId',
      headerName: 'Beszállító kapcsolattartó',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.employee,
      renderCell: (data) => {
        return data.row.contactPerson?.name;
      },
    },
    {
      field: 'supplierEmail',
      headerName: 'Beszállító email',
      type: 'string',
    },
    {
      field: 'supplierPhoneNumber',
      headerName: 'Beszállító telefonszáma',
      type: 'string',
    },
    {
      field: 'supplierComplaintId',
      headerName: 'Reklamáció azonosító',
      type: 'singleSelect',
      renderCell: (data) => {
        const finded = autocompleteData?.complaints?.find(
          (complaint) => complaint.id === data.row.supplierComplaintId
        )?.reference;
        return finded;
      },
      valueOptions: complaintValueOptions,
    },
    {
      field: 'itemCode',
      headerName: 'Rajzszám / Cikkszám',
      type: 'string',
    },
    {
      field: 'supplierComplaintDate',
      headerName: 'Reklamáció dátuma',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.supplierComplaintDate);
      },
    },
    {
      field: 'companyId',
      headerName: 'Vevő',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.company,
    },
    {
      field: 'customerContactPerson',
      headerName: 'Vevő kapcsolattartó',
      type: 'string',
    },
    {
      field: 'customerEmail',
      headerName: 'Vevő email',
      type: 'string',
    },
    {
      field: 'customerPhoneNumber',
      headerName: 'Vevő telefonszáma',
      type: 'string',
    },
  ]);

  return (
    <DatagridPremiumUi
      key={type === ReportType.REPORT4D ? DataGridIdentifiers.ComplaintReport4D : DataGridIdentifiers.ComplaintReport8D}
      datagridIdentifier={
        type === ReportType.REPORT4D ? DataGridIdentifiers.ComplaintReport4D : DataGridIdentifiers.ComplaintReport8D
      }
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default ComplaintReports;
